import React, { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getInstitutionDetails } from '../store/actions'
import { baseURL2 } from '../helper/helper'
import buildingImg from '../assets/building.jpg'

export default function InstitutionDetails() {
    const { slug } = useParams()
    const dispatch = useDispatch()
    const { selectedInstitution, loading } = useSelector((state) => state.reducer || {})

    console.log(selectedInstitution)

    useEffect(() => {
        if (slug) {
            dispatch(getInstitutionDetails(slug))
        }
        window.scrollTo(0, 0)
    }, [dispatch, slug])

    const inst = selectedInstitution

    const getImageUrl = (path) => {
        if (!path) return buildingImg;
        if (path.startsWith('http')) return path;
        return baseURL2 + path;
    }

    if (loading && !inst) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white uppercase tracking-[4px] text-secondary animate-pulse font-bold text-sm">
                Loading Details...
            </div>
        )
    }

    if (!inst) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-white p-8 text-center text-gray-900">
                <h2 className="text-2xl font-light mb-4 text-primary">Branch Not Found</h2>
                <Link to="/" className="text-sm text-secondary uppercase tracking-widest underline underline-offset-4 font-bold">
                    Return to Home
                </Link>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center">
                <span className="text-xs tracking-widest uppercase text-secondary font-bold mb-6 block">Branch Profiling</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8">
                    {inst?.name}
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed border-l-4 border-secondary/20 pl-6 bg-primary/5 rounded-r-3xl p-6 italic">
                    "{inst?.mission || "A prestigious center of specialized knowledge dedicated to nurturing the next generation of spiritual and intellectual leaders."}"
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 mb-24">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-primary text-white p-12 md:p-16 flex flex-col justify-center rounded-[40px] shadow-lg shadow-primary/20 relative overflow-hidden group">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-secondary/10 rounded-full blur-2xl group-hover:bg-secondary/20 transition-colors pointer-events-none"></div>
                        <span className="text-xs uppercase tracking-widest text-secondary mb-6 block font-bold">Vision</span>
                        <p className="text-lg leading-relaxed font-light italic">
                            "{inst?.vision || "To be a leading center of excellence in education blending Islamic values with modern knowledge."}"
                        </p>
                    </div>
                    <div className="bg-secondary text-white p-12 md:p-16 flex flex-col justify-center rounded-[40px] shadow-lg shadow-secondary/20 relative overflow-hidden group">
                        <div className="absolute bottom-0 right-0 w-32 h-32 bg-primary/10 rounded-full blur-2xl group-hover:bg-primary/20 transition-colors pointer-events-none"></div>
                        <span className="text-xs uppercase tracking-widest text-primary mb-6 block font-bold">Mission</span>
                        <p className="text-lg leading-relaxed font-light italic">
                            "{inst?.mission || "Providing holistic education that integrates Islamic teachings with academic discipline."}"
                        </p>
                    </div>
                </div>
            </section>

            <section className="max-w-4xl mx-auto px-6 mb-24">
                <div className="mb-16">
                    <h2 className="text-3xl font-light text-primary mb-6">Foundational Narrative</h2>
                    <div className="w-12 h-px bg-secondary mb-8"></div>
                    <div className="prose prose-lg max-w-none text-gray-600 font-light leading-relaxed whitespace-pre-line border-l-2 border-primary/10 pl-6">
                        {inst?.description}
                    </div>
                </div>
            </section>

            {inst?.teachers && inst?.teachers?.length > 0 && (
                <section className="max-w-7xl mx-auto px-6 md:px-12 mb-24 border-t border-gray-100 pt-24">
                    <h3 className="text-3xl font-light text-primary mb-12">Learned Mentors</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {[...inst?.teachers].sort((a, b) => {
                            const teacherOrder = ['Sibtain', 'Kalim', 'Haid', 'Nikhat', 'Rukhsana'];
                            const indexA = teacherOrder.findIndex(name => a.name?.toLowerCase().includes(name.toLowerCase()));
                            const indexB = teacherOrder.findIndex(name => b.name?.toLowerCase().includes(name.toLowerCase()));
                            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                            if (indexA !== -1) return -1;
                            if (indexB !== -1) return 1;
                            return 0;
                        }).map((teacher) => (
                            <div key={teacher?.id} className="flex flex-col sm:flex-row gap-8 items-start p-8 bg-primary/5 rounded-[40px] border border-primary/10 hover:-translate-y-1 transition-transform">
                                <div className="w-24 h-24 bg-white rounded-full overflow-hidden shrink-0 shadow-md border-2 border-white">
                                    {teacher?.photo ? (
                                        <img loading="lazy" src={getImageUrl(teacher?.photo)} alt={teacher?.name} className="w-full h-full object-cover" />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-gray-300">No Image</div>
                                    )}
                                </div>
                                <div className="flex-1 text-left">
                                    <span className="text-xs font-bold text-secondary uppercase tracking-widest block mb-2">{teacher?.expertise}</span>
                                    <h4 className="font-light text-primary text-2xl mb-4">{teacher?.name}</h4>
                                    <p className="text-gray-500 text-sm leading-relaxed mb-6 font-light italic">"{teacher?.experience}"</p>
                                    <div className="flex flex-wrap gap-2">
                                        {teacher?.education?.split('\r\n').map((edu, eidx) => (
                                            <span key={eidx} className="bg-white border border-gray-200 px-3 py-1 rounded-lg text-[10px] uppercase font-bold tracking-widest text-gray-400">{edu}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            <section className="max-w-7xl mx-auto px-6 md:px-12 border-t border-gray-100 pt-24">
                <h3 className="text-3xl font-light text-primary mb-12">Academic Modules</h3>
                <div className="space-y-16">
                    {inst?.courses?.map((course) => (
                        <div key={course.id} className="bg-white rounded-[40px] border border-gray-100 shadow-sm p-8 md:p-12 hover:border-primary/20 transition-colors">
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8 mb-12 pb-8 border-b border-gray-100">
                                <div>
                                    <h4 className="text-2xl font-medium text-primary mb-4">{course?.name}</h4>
                                    <p className="text-secondary text-xs font-bold uppercase tracking-widest">Subjects: <span className="font-medium text-gray-500">{course?.subjects}</span></p>
                                </div>
                                <div className="text-left md:text-right bg-primary/5 p-4 rounded-2xl border border-primary/10">
                                    <span className="text-[10px] text-gray-500 font-bold uppercase tracking-widest block mb-2">Admission Fee</span>
                                    <span className="text-primary font-medium text-2xl">₹{course?.base_admission_fee}</span>
                                </div>
                            </div>

                            {course?.grades && course?.grades?.length > 0 && (
                                <div className="overflow-x-auto">
                                    <table className="w-full text-left border-separate border-spacing-y-2">
                                        <thead>
                                            <tr className="text-primary text-[10px] uppercase font-bold tracking-[4px]">
                                                <th className="pb-4 font-bold pl-4">Grade Level</th>
                                                <th className="pb-4 font-bold text-right pr-4">Annual Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[...(course?.grades || [])].sort((a, b) => {
                                                const order = ['J.KG', 'S.KG', 'Nursery', 'Ibtida', '1st', 'First', 'Auwal', '2nd', 'Second', 'Duwam', '3rd', 'Third', 'Suwam', 'LKG', 'UKG', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th'];
                                                const indexA = order.findIndex(o => a.grade_name?.toLowerCase().includes(o.toLowerCase()));
                                                const indexB = order.findIndex(o => b.grade_name?.toLowerCase().includes(o.toLowerCase()));
                                                if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                                                if (indexA !== -1) return -1;
                                                if (indexB !== -1) return 1;
                                                return a.grade_name.localeCompare(b.grade_name);
                                            }).map((grade, gIdx) => (
                                                <tr key={grade.id || `${grade.grade_name}-${gIdx}`} className="bg-gray-50 rounded-xl overflow-hidden hover:bg-primary/5 transition-colors">
                                                    <td className="py-5 pl-4 text-gray-900 font-medium rounded-l-xl">{grade?.grade_name}</td>
                                                    <td className="py-5 pr-4 text-right text-secondary font-bold text-lg rounded-r-xl">₹{grade?.annual_fee}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}
